export const edyEduOrganizationsTranslations = {
  lv: {
    title: 'Izglītības iestādes',
    tabs: {
      label: 'Izglītības iestāžu sadaļas',
      institutions: 'Izglītības iestādes',
      goLive: 'Piekļuves pieprasījumi',
    },
    search: 'Meklēt pēc nosaukuma vai reģistrācijas numura',
    empty: 'Izglītības iestādes nav atrastas',
    columns: {
      name: 'Nosaukums',
      endUserNo: 'Klienta nr.',
      regNo: 'Reģ. nr.',
      activeInternships: 'Aktīvās prakses',
      userCount: 'Lietotāji',
    },
    goLive: {
      empty: 'Piekļuves pieprasījumu nav',
      accept: 'Pieņemt',
      acceptTitle: 'Pieņemt piekļuves pieprasījumu',
      acceptHelp:
        'Izglītības iestāde un tās testa prakses tiks aktivizētas, un pieprasītājs saņems e-pastu.',
      accepted: 'Piekļuves pieprasījums pieņemts',
      decline: 'Noraidīt',
      declineTitle: 'Noraidīt piekļuves pieprasījumu',
      declineHelp:
        'Iemesls tiks parādīts izglītības iestādes administratoriem paziņojumā, un pieprasītājs saņems e-pastu.',
      reason: 'Iemesls',
      reasonRequired: 'Norādiet iemeslu',
      declined: 'Piekļuves pieprasījums noraidīts',
      error: 'Neizdevās apstrādāt pieprasījumu',
      columns: {
        orgName: 'Izglītības iestāde',
        requestedAt: 'Pieprasīts',
        userEmail: 'E-pasts',
        userPhone: 'Tālrunis',
        info: 'Informācija',
      },
    },
    detail: {
      backToList: 'Atpakaļ uz sarakstu',
      email: 'E-pasts',
      phone: 'Tālrunis',
      webSite: 'Mājaslapa',
      logo: 'Logotips',
      noLogo: 'Nav logotipa',
      tabsLabel: 'Izglītības iestādes sadaļas',
      users: 'Lietotāji',
    },
  },
  en: {
    title: 'Educational institutions',
    tabs: {
      label: 'Educational institution sections',
      institutions: 'Educational institutions',
      goLive: 'Go-live requests',
    },
    search: 'Search by name or registration number',
    empty: 'No educational institutions found',
    columns: {
      name: 'Name',
      endUserNo: 'Customer no.',
      regNo: 'Reg. no.',
      activeInternships: 'Active internships',
      userCount: 'Users',
    },
    goLive: {
      empty: 'No go-live requests',
      accept: 'Accept',
      acceptTitle: 'Accept the go-live request',
      acceptHelp:
        'The educational institution and its test internships will be activated, and the requester will receive an e-mail.',
      accepted: 'Go-live request accepted',
      decline: 'Decline',
      declineTitle: 'Decline the go-live request',
      declineHelp:
        "The reason will be shown to the institution's administrators in a notification, and the requester will receive an e-mail.",
      reason: 'Reason',
      reasonRequired: 'Enter a reason',
      declined: 'Go-live request declined',
      error: 'Could not process the request',
      columns: {
        orgName: 'Educational institution',
        requestedAt: 'Requested',
        userEmail: 'Email',
        userPhone: 'Phone',
        info: 'Information',
      },
    },
    detail: {
      backToList: 'Back to the list',
      email: 'Email',
      phone: 'Phone',
      webSite: 'Web page',
      logo: 'Logo',
      noLogo: 'No logo',
      tabsLabel: 'Educational institution sections',
      users: 'Users',
    },
  },
}
